export const RouteAccess = {
  PUBLIC: 'PUBLIC',
  PRIVATE: 'PRIVATE',
  COMMON: 'COMMON',
};


export default RouteAccess;